<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="3.4266mm" height="5mm" version="1.1"
    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
    viewBox="0 0 5173 7548"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Vrstva_x0020_3">
      <path class="fil0 str0" d="M4057 2172l0 -1701c0,-260 -197,-471 -457,-471 -260,0 -456,211 -456,471l0 1701 -1217 0 0 -1701c0,-260 -146,-471 -406,-471 -260,0 -405,211 -405,471l0 1701 -1116 0 0 3843c0,446 345,823 792,823l1236 0 0 710 1015 0 0 -710 1304 0c447,0 826,-377 826,-823l0 -3843 -1116 0z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Device',
};
</script>

<style scoped>
.fil0 {fill:gray;fill-rule:nonzero}
.str0 {stroke:#666666;stroke-width:100}
</style>
